import { enqueueSnackbar } from "notistack"
import { SNACKBAR_MESSAGES } from "../Data/constant"

//  Main global function

export const showSnackbar = (message, variant = "default", options = {}) => {
    const translatedMessage =
        typeof window?.voiceiiTags === "function" ? window.voiceiiTags(message) : message

    enqueueSnackbar(translatedMessage, {
        variant,
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        ...options,
    })
}

//  Helper shortcuts
export const showSuccess = (msg = SNACKBAR_MESSAGES.SUCCESS_DEFAULT, options) =>
    showSnackbar(msg, "success", options)

export const showError = (msg = SNACKBAR_MESSAGES.ERROR_DEFAULT, options) =>
    showSnackbar(msg, "error", options)

export const showWarning = (msg = SNACKBAR_MESSAGES.WARNING_DEFAULT, options) =>
    showSnackbar(msg, "warning", options)

export const showInfo = (msg = SNACKBAR_MESSAGES.INFO_DEFAULT, options) =>
    showSnackbar(msg, "info", options)
